// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"7374":"9dbff2e13711323a","9520":"a7136bbb100e87be"}[chunkId] + ".css";
};